import { Stack, Typography, Avatar } from "@mui/material";

export default function UserControl(props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 1,
        marginBottom: 1,
      }}
    >
      <Typography variant="caption" color="secondary.light">
        {`${props.isCreator ? "Created By:" : "Modified By:"}`}
      </Typography>

      <Typography style={{ marginLeft: 4 }} variant="caption">
        {props.user}
      </Typography>

      <Avatar
        sx={{ width: 22, height: 22 }}
        alt={`${props.isCreator ? "Created User Icon" : "Modified User Icon"}`}
        src={`https://firebasestorage.googleapis.com/v0/b/becx-eb075.firebasestorage.app/o/users%2F${props.uid || "default"}%2FprofilePic.jpg?alt=media`}
      />
    </Stack>
  );
}
